/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitLogoListByCompanyIdResults,
    PressKitLogoListByCompanyIdResultsFromJSON,
    PressKitLogoListByCompanyIdResultsFromJSONTyped,
    PressKitLogoListByCompanyIdResultsToJSON,
} from './PressKitLogoListByCompanyIdResults';

/**
 * 企業のプレスキットのロゴ一覧
 * @export
 * @interface PressKitLogoListByCompanyId
 */
export interface PressKitLogoListByCompanyId {
    /**
     * 企業のプレスキットのロゴの総数
     * @type {number}
     * @memberof PressKitLogoListByCompanyId
     */
    total: number;
    /**
     * プレスキットロゴ一覧。仕様上は最大50件。
     * @type {Array<PressKitLogoListByCompanyIdResults>}
     * @memberof PressKitLogoListByCompanyId
     */
    results: Array<PressKitLogoListByCompanyIdResults>;
}

export function PressKitLogoListByCompanyIdFromJSON(json: any): PressKitLogoListByCompanyId {
    return PressKitLogoListByCompanyIdFromJSONTyped(json, false);
}

export function PressKitLogoListByCompanyIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitLogoListByCompanyId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(PressKitLogoListByCompanyIdResultsFromJSON)),
    };
}

export function PressKitLogoListByCompanyIdToJSON(value?: PressKitLogoListByCompanyId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(PressKitLogoListByCompanyIdResultsToJSON)),
    };
}

